import WhiteHeaderCard from "../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import React, {useEffect} from "react";
import {CircularProgress, makeStyles, useMediaQuery} from "@material-ui/core";
import {colors} from "../../../colors";
import {useDispatch, useSelector} from "react-redux";
import {shouldAuthenticate} from "../../../utils/guard";
import * as actions from "../../../../store";
import PropTypes from "prop-types";

const useStyles = makeStyles({
    cardContent: {
        color: colors.font.light,
    },
    contentOverline: {
        fontSize: "0.75rem",
    },
    cardContentWithoutButton: {
        minHeight: "200px",
    },
    breakWord: {
        wordBreak: "break-word",
    },
    maxWidth: {
        width: "100%",
    },
});

const ServizioClientiPremiumCard = ({...props}) => {
    const classes = useStyles();
    const smScreen = useMediaQuery("(max-width: 450px)");

    const userClaims = useSelector(state => state.authReducer.userClaims)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const contactNumbers = useSelector(state => state.authReducer.contactNumbers)
    const loadingNumbers = useSelector(state => state.authReducer.loadingContactNumbers)
    const dispatch = useDispatch();

    const isPremium = selectedCompany.livelloDiAssistenza === "Premium";

    useEffect(() => {
        dispatch(actions.getContactNumbersForCustomer(selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId))
    }, [dispatch, selectedCompany.integrationId, selectedCompany.livelloDiAssistenzaId])

    return (
        <WhiteHeaderCard elevationValue={props.elevationValue} title={`Servizio Clienti ${isPremium ? "Premium" : ""}`}>
            <div className={classes.cardContentWithoutButton}>
                <Typography variant="body2" className={classes.cardContent}>
                    {contactNumbers.headerCaption}
                </Typography>

                <Grid container className={"mt-6"} spacing={2} justifyContent="space-between">
                    {loadingNumbers ? <CircularProgress size={80} className={"mt-32 "}/> : <>
                        {contactNumbers.firstNumber ?
                            <Grid item xs={12} lg={6}>
                                <Typography variant={"body2"}
                                            className={classes.contentOverline + " " + classes.cardContent}>
                                    {contactNumbers.firstNumberCaption}
                                </Typography>
                                <Typography variant={"h5"}>
                                    {contactNumbers.firstNumber}
                                </Typography>
                            </Grid> : null}

                        {contactNumbers.showSecondNumber ?
                            <Grid item xs={12} lg={userClaims.isConsipCustomer ? 6 : 12}>
                                <Typography variant={"body2"}
                                            className={classes.contentOverline + " " + classes.cardContent}>
                                    {contactNumbers.secondNumberCaption}
                                </Typography>
                                <Typography variant={"h5"} style={{wordWrap: 'no-wrap'}}>
                                    {contactNumbers.secondNumber}
                                </Typography>
                            </Grid>
                            : null}


                        {contactNumbers.pinNumber ?
                            <Grid item xs={12}>
                                <Typography variant={"body2"}
                                            className={classes.contentOverline + " " + classes.cardContent}>
                                    {contactNumbers.pinCaption}
                                </Typography>
                                <Typography variant={"h5"}>
                                    {contactNumbers.pinNumber}
                                </Typography>
                            </Grid> : null}
                    </>}
                </Grid>

            </div>
            <Button
                className={smScreen ? classes.maxWidth : null}
                onClick={props.handleOpenAltereComunicazioni}
                variant={"outlined"}
                color={"secondary"}
                disabled={!shouldAuthenticate("C", userClaims.typeUser, userClaims.roles)}
            >
                contattaci
            </Button>
        </WhiteHeaderCard>

    );
}

ServizioClientiPremiumCard.defaultProps = {
    elevationValue: 0,
    disableSr: false
};

ServizioClientiPremiumCard.propTypes = {
    elevationValue: PropTypes.number,
    data: PropTypes.object
}


export default ServizioClientiPremiumCard;
